import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';

export default function BackgroundGatsbyImage(
    props: { children?: any; image: string },
    ...otherProps: any
) {
    const { children, image } = props;

    return (
        <>
            {image && (
                <GatsbyImage
                    image={image}
                    style={{
                        position: `absolute`,
                        width: `100%`,
                        height: `100%`,
                    }}
                    alt=''
                    {...otherProps}
                >
                    {children}
                </GatsbyImage>
            )}
        </>
    );
}
